import { render, staticRenderFns } from "./Behavior.vue?vue&type=template&id=363049c8&scoped=true&"
import script from "./Behavior.vue?vue&type=script&lang=js&"
export * from "./Behavior.vue?vue&type=script&lang=js&"
import style0 from "./Behavior.vue?vue&type=style&index=0&id=363049c8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "363049c8",
  null
  
)

export default component.exports